import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";

interface UseScrollMore {
  isVisible: boolean;
  firstTimeEnded: boolean;
  position: number;
  isDismissScrollMore: () => boolean;
  onDismissScrollMore: () => void;
}

export const useScrollMore = ({
  isVisible,
  firstTimeEnded,
  position,
  isDismissScrollMore,
  onDismissScrollMore
}: UseScrollMore): boolean => {
  const location = useLocation();
  const isOnWatchPage = useMemo(() => location.pathname.includes("/watch"), [location.pathname]);
  const commonConditions = position === 1 && isOnWatchPage && !isDismissScrollMore();

  const isShowScrollMore = useMemo(
    () => commonConditions && firstTimeEnded,
    [firstTimeEnded, commonConditions]
  );

  useEffect(() => {
    if (!isVisible && commonConditions) {
      onDismissScrollMore();
    }
  }, [isVisible, commonConditions, onDismissScrollMore]);

  return isShowScrollMore;
};
